import { axios, API, SendRequest} from '@/imports-files/components/model/custom-company-integration-modal.js';
         

export class SelectJobModalService extends SendRequest
{
    async getPreviousImportData(params)
    {
        const url = API.client.jobs.GET_IMPORT_JOB_TEMPLATE_DATA;
        try
        {
        const result = await axios.get( url,
            {
                params: params,
                headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
        } 
        catch (error) 
        {
        return error;
        }
    }

    async importJob(params)
    {
        const url = API.client.jobs.IMPORT_JOB_TEMPLATE;
        try
        {
        const result = await axios.post( url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
        } 
        catch (error) 
        {
        return error;
        }
    }
}
